import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AccordionComponent } from '@domgen/dgx-fe-components/accordion';
import { RichTextComponent } from '@domgen/dgx-fe-components/content';
import { IconComponent } from '@domgen/dgx-fe-components/icon';
import { ProtectionBenefitsAccordionPanel } from '@us-registration/util-models';

@Component({
  selector: 'us-registration-protection-details-accordion-panel',
  templateUrl: './protection-details-accordion-panel.component.html',
  styleUrls: ['./protection-details-accordion-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AccordionComponent, IconComponent, NgClass, RichTextComponent],
})
export class ProtectionDetailsAccordionPanelComponent {
  @Input() isDesktop?: boolean;
  @Input() panels: ProtectionBenefitsAccordionPanel[] = [];
}
